<template>
    <div class="counter_list__wrapper">
        <div class="counter_list" :class="classShow">
            <span class="counter_list__label">{{ counterLabel }}</span>
        </div>
    </div>
</template>

<script>

export default {
    name: "counter_list",
    props: {
        isShow: {
            type: Boolean,
            required: true,
        },
        counterCurrent: {
            type: Number,
            required: true,
            default: 0,
        },
        counterTotal: {
            type: Number,
            required: true,
            default: 0,
        }
    },
    emits: [],
    components: {},
    mixins: [],
    data() {
        return {}
    },
    methods: {},
    computed: {
        counterLabel(){
            return this.counterCurrent + ' / ' + this.counterTotal;
        },
        classShow(){
            if (this.isShow) {
                return {'show': true};
            }
            return {'show': false};
        }
    },
    watch: {}
}
</script>
